import SlimSelect from 'slim-select'

const initSlimSelect = () => {
    document.querySelectorAll('select[data-slim-select]').forEach((el) => {
      if (el.slim) {
        return
      }

      const [firstLabel] = el.labels ?? []

      // eslint-disable-next-line no-new
      new SlimSelect({
        select: el,
        settings: {
          ariaLabel: firstLabel?.textContent?.trim() ?? '',
          modal: 'off', // 4.x opens a modal dialog instead of the dropdown below 768px by default
          searchHighlight: true,
          showSearch: el.dataset.slimSelectSearch !== 'false',
        },
      })
    })
  },
  destroySlimSelectsIn = (root) => {
    root.querySelectorAll('select[data-slim-select]').forEach((el) => {
      el.slim?.destroy()
    })
  }

document.addEventListener('turbo:load', initSlimSelect)
document.addEventListener('turbo:frame-render', initSlimSelect)
document.addEventListener('condition:fields-added', initSlimSelect)

// Tear down before Turbo caches the page snapshot so a Back/Forward restore
// doesn't double-render: `el.slim` is a runtime property that doesn't survive caching.
document.addEventListener('turbo:before-cache', () => {
  destroySlimSelectsIn(document)
})

// Tear down before Turbo swaps a frame's contents, otherwise the document-root
// .ss-content panel for any select inside the outgoing frame is left orphaned.
document.addEventListener('turbo:before-frame-render', (event) => {
  destroySlimSelectsIn(event.target)
})

// Allow the rule form's row-remove handler to clean up before yanking the row
// out of the DOM, otherwise the document-root .ss-content panel and per-instance
// window/document listeners leak.
document.addEventListener('condition:fields-removing', (event) => {
  destroySlimSelectsIn(event.detail.row)
})
